import transformInboxItem from './transformInboxItem';

// Massage the folder response to make it closer to what the FE expects
export default folder => ({
  ...folder,
  items: folder.items.map(transformInboxItem),
});
